import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import cx from 'classnames';
import {validate} from '../validation';


@connect(
  state => ({
    submitted: state.ui.submitted
  })
)
export default class Field extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.element,
    validators: PropTypes.arrayOf(PropTypes.func),
    errors: PropTypes.arrayOf(PropTypes.string),
    setErrors: PropTypes.func,
    stacked: PropTypes.bool
  };

  render() {
    let {className, label, children, value, errors, submitted, stacked = false, showLabel = false, style} = this.props;
    let child = children ?
      React.cloneElement(children, {
        value,
        label,
        onChange: this._onChange
      }) : null;

    return (
      <div className={cx("field", {"has-errors": submitted && errors.length > 0, stacked}, className)} style={style}>
        {(label && showLabel) && <label className="campus-text">{label}</label>}
        <div className="input">
          {child}
        </div>
        {submitted && errors.length > 0 && <div className="errors">
          {errors.map(i =>
            <div key={i} className="error">{i}</div>
          )}
        </div>}
      </div>
    );
  }

  _onChange = (value) => {
    this.props.onChange(value);
    this.props.setErrors(validate(value, this.props.validators));
  }
}


// WEBPACK FOOTER //
// ./src/components/Field.js